<template>
    <div>
        <images-upload
            v-for="(item, idx) in fileList"
            :key="idx"
            :multiple="multiple"
            :url="item.url"
            :auto-upload="false"
            @change="beforeUpload"
        />
    </div>
</template>
<script>
import ImagesUpload from 'components/upload/ImageUpload';
import upload from 'mixins/upload';
import uploadMinxis from './uploadMinxis';
import { Promise } from 'q';
export default {
    mixins: [upload, uploadMinxis],
    components: {
        ImagesUpload
    },
    props: {
        action: {
            type: String,
            default: ''
        },
        max: {
            type: Number,
            default: 3
        },
        fileSize: {
            // KB
            type: Number,
            default: 1024 * 1024
        },
        fileList: {
            type: Array
        },
        index: {
            type: Number,
            default: 0
        },
        extra: {
            type: Object
        },
        limit: {
            type: Number
        },
        multiple: {
            type: Boolean
        }
    },
    mounted() {
        console.log(this.fileList);
    },
    methods: {
        beforeUpload(files) {
            // console.log(files)
            let all = [];
            for (let j = 0; j < files.length; j++) {
                if (j + this.index >= this.limit) break;
                all.push(this.handleUploadImage(files[j]));
            }

            new Promise.all(all)
                .then(urls => {
                    this.$emit('change', urls, this.extra);
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
};
</script>
